<template>
  <div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="header">
          <h2>앱</h2>
        </div>
        <div class="body">
          <h2 class="card-inside-title">이름 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  maxlength="50"
                  v-model="name"
                  placeholder="이름"
                />
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">설명 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <div class="form-line">
                  <textarea
                    rows="4"
                    class="form-control no-resize"
                    v-model="text"
                    placeholder="해당 앱에 대한 설명을 적어주세요"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">로고</h2>
          <div class="row clearfix">
            <div class="col-xl-10 col-lg-12 col-md-12">
              <div class="card">
                <div class="body">
                  <div class="dz-message">
                    <form
                      action="/"
                      id="frmFileUpload"
                      class="dropzone"
                      method="post"
                      enctype="multipart/form-data"
                      @click="activeFileForm"
                    >
                      <div class="dz-message">
                        <h4>클릭하여 이미지를 추가하세요</h4>
                      </div>

                      <div class="fallback">
                        <input
                          name="file"
                          type="file"
                          ref="file"
                          @change="uploadComplete"
                          hidden
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-lg-12 col-md-12">
              <div class="card">
                <div class="body" style="">
                  <div class="dz-image" style="width: 100%; height: 150px">
                    <img
                      id="imagePreview"
                      :src="getPreviewed"
                      style="width: 100%; height: 150px; object-fit: contain"
                    />
                  </div>
                  <div
                    class="dz-success-mark"
                    style="position: absolute; top: 0; right: 0%"
                  >
                    <button
                      type="button"
                      class="btn"
                      style="font-size: 20px; color: #979797"
                      @click="removeImg"
                    >
                      <font-awesome-icon :icon="faTimes" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">상태 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <select class="form-control" v-model="view">
                <option value="Y">공개</option>
                <option value="N">비공개</option>
              </select>
            </div>
          </div>

          <h2 class="card-inside-title">관계</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <select class="form-control" v-model="relation">
                <option value="employed">나는 고용되었다</option>
                <option value="employed-usage">
                  나는 기능 완성을 위해 고용되었다.
                </option>
                <option value="etc">관련이 없다.</option>
              </select>
            </div>
          </div>

          <h2 class="card-inside-title">카테고리</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <select class="form-control" v-model="category">
                <option value="accounting">Accounting</option>
                <option value="ad">광고</option>
                <option value="app develop">앱 개발</option>
                <option value="calendar">달력</option>
                <option value="database">데이타베이스</option>
                <option value="dev tool">개발툴</option>
                <option value="etc">기타등등</option>
              </select>
            </div>
          </div>

          <h2 class="card-inside-title">뉴스레터 받기</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="c_checkbox">
                  <input type="checkbox" v-model="newsletter" />
                  <span class="checkmark"></span>
                  <span class="ml-2">업데이트 소식 받기</span>
                </label>
              </div>
            </div>
          </div>

          <div class="row clearfix" v-if="!btnChange">
            <div class="col-sm-12">
              <div class="form-group" style="text-align: right">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="toMakingPage"
                  :disabled="saveBtn"
                >
                  저장
                </button>
                <button class="btn btn-default" type="button" @click="toDevelop">
                  취소
                </button>

              </div>
            </div>
          </div>

          <div class="row clearfix" v-if="btnChange">
            <div class="col-sm-12">
              <div class="form-group" style="text-align: right">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="toMakingPageFromVersion"
                >
                  저장
                </button>
                <!-- <router-link to="/developer/main"><button class="btn btn-default" type="button" >취소</button></router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://sdk.amazonaws.com/js/aws-sdk-2.283.1.min.js"></script>

<script>

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
const aws = require("aws-sdk");

// import Urls from "@/common/urls";
// import Apiroot from "@/common/apiroot";
import eventbus from "@/store/modules/devEventBus";

aws.config.update({
  region: "ap-northeast-2",
  credentials: new aws.CognitoIdentityCredentials({
    IdentityPoolId: "ap-northeast-2:58dd1fe3-0e1b-4b18-8e10-18c4f9172bc5",
  }),
});
const s3 = new aws.S3({
  // apiVersion: '2006-03-01',
  // params: {Bucket: albumBucketName}
});



export default {
  name: "DevelopCreatePage",
  components: {
    vueDropzone: vue2Dropzone,
    FontAwesomeIcon,
  },
  props: ["nowPage"],
  data() {
    return {
      // previewed : false,
      appCode: null,
      imgPath: null,

      name: null,
      text: null,
      view: null,
      relation: null,
      category: null,
      newsletter: true,
      versions: null,

      btnChange: false,
      saveBtn:false,

      faTimes,
    };
  },
  methods: {
    toDevelop(){
      this.$router.push({name:'DevelopPage'})
    },
    uploadComplete() {
      console.log(
        "이미지 있는지 없는지 확인 : ",
        this.$store.state.s3Image.imgPath
      );

      // if (
      //   this.$store.state.s3Image.imgPath == null ||
      //   this.$store.state.s3Image.imgPath == ""
      // ) {
        this.$store.dispatch("uploadImage", { file: this.$refs.file.files[0] });
        console.log("upload complate");
        this.previewed = true;
      // } else {
      //   this.$store
      //     .dispatch("removeImage", { file: this.$store.state.s3Image.imgPath })
      //     .then(() => {
      //       this.$store.dispatch("uploadImage", {
      //         file: this.$refs.file.files[0],
      //       });
      //     });
      // }
    },

    removeImg() {
      if(confirm("이미지를 삭제하시겠습니까?")){
        //삭제 되었으면 이미지 미리보기 띄우기
        this.$store.dispatch("removeImage", {
          file: this.$store.state.s3Image.imgPath,
        });
        this.previewed = false;

      }
    },

    toMakingPage() {
      console.log("데이터 확이ㄴ: ");
      console.log(
        this.name,
        this.text,
        this.$store.state.s3Image.imgPath,
        this.relation
      );
      if(this.name.length > 0){
        this.name = this.name.replace(/(\s*)/g, "")
      }

      if (this.name == null || this.name == "") {
        alert("이름을 입력해주세요.");
        return;
      }


      if (this.text == null || this.text == "") {
        alert("설명을 입력해주세요.");
        return;
      }

      if (this.view == null) {
        alert("상태를 선택해주세요.");
        return;
      }

      this.saveBtn = true

      var param = {
        appName: this.name,
        appText: this.text,
        appImage: this.$store.state.s3Image.imgPath,
        appCategory: this.category,
        appRelationship: this.relation,
        appNewsletter: this.newsletter,
        viewYn: this.view,
        versionCode: this.versions,
        userCode: this.$store.state.userStore.userCode,
        appCode: this.appCode,
      };

      this.api.createApp(param)
        .then(() => {
          this.saveBtn = false
          alert("저장되었습니다.");
          this.$router.push({name:"DevelopPage"});
        })
        .catch(() => alert("오류가 발생했습니다."));

      //   this.$router.push({name : 'DevMain', params : {appId : 'ttt'}})
    },
    toMakingPageFromVersion() {
      console.log("sdfdsd");

      var param = {
        appName: this.name,
        appText: this.text,
        appImage: this.$store.state.s3Image.imgPath,
        appCategory: this.category,
        appRelationship: this.relation,
        appNewsletter: this.newsletter,
        viewYn: this.view,

        userCode: this.$store.state.userStore.userCode,
        appCode: this.$store.state.devStore.appCode,
      };

      this.api.createApi(param)
        .then(() => {
          alert("저장되었습니다.");

          this.btnChange = false;
          eventbus.$emit("closeBtn");
          //  this.$router.push('/developer/main')
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
    activeFileForm() {
      this.$refs.file.click();
    },
  },
  computed : {
    getPreviewed() {
      if (
        this.$store.state.s3Image.imgPath != null &&
        this.$store.state.s3Image.imgPath != ""
      ) {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          this.$store.state.s3Image.imgPath
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
    status() {
      if (this.$route.params.appId != null) {
        return "수정";
      } else {
        return "생성";
      }
    },
  },
  created() {
    console.log("DevelopCreatePage.created");
    this.versions = '1.0.0';

    if (this.$route.params.appCode != null) {
      console.log(this.$route.params.appCode);

      var param = {
        userCode: this.$store.getters.getUserCode,
        appCode: this.$route.params.appCode,
      };

      this.api.appDetail(param)
        .then((res) => {
          if(this.utils.preApiHandle(res)) {
            console.log("dev create page res : ", res)
          }

          console.log("결과값:", res);
          this.name = res.app.appName;
          this.text = res.app.appText;
          this.view = res.app.viewYn;
          this.category = res.app.appCategory;
          this.relation = res.app.appRelationship;
          this.appCode = res.app.appCode;

          if (res.app.versionCode != null) {
            this.versions = res.app.versionCode;
          }

          //앱수정 부분 이미지 관련 해서 테스트 해보기이이이이이 중요
          if (res.app.appImage != null && res.app.appImage != "") {
            this.$store.state.s3Image.imgPath = res.app.appImage.replace(
              /""/gi,
              ""
            );
            // this.getPreviewed()
          }
        })
        .catch(() => alert("오류가 발생했습니다. app detail"));
    }
  },
  mounted() {
    console.log("DevelopCreatePage.mounted");
  },
  beforeDestroy() {
    console.log("DevelopCreatePage.beforeDestroy");
    this.$store.state.s3Image.imgPath = null;
  }
}
</script>


